import { getContent } from '../core/store.js';
import { renderProducts } from '../components/product.js';
import { getDomElements } from '../utils/dom.js';

export function renderHomePage() {
    const domRefs = getDomElements();
    if (!domRefs.pageContent) return;

    // Clear current content
    domRefs.pageContent.innerHTML = '';

    // Create basic home page structure
    const logoDiv = document.createElement('div');
    logoDiv.className = 'logo logo--wide';
    logoDiv.id = 'logo';

    const productDiv = document.createElement('div');
    productDiv.className = 'product-container hidden';

    domRefs.pageContent.appendChild(logoDiv);
    domRefs.pageContent.appendChild(productDiv);

    // Update home page specific content
    updateLogo();

    // Populate products
    renderProducts('.product-container');
}

function updateLogo() {
    const content = getContent();
    if (!content) return;

    const homepageItem = content.find(item => item?.name?.toLowerCase() === "homepage");
    if (!homepageItem) {
        console.warn("no homepage item found in content data");
        return;
    }

    // Get logo container
    const logoContainer = document.getElementById('logo');
    if (!logoContainer) return;

    // Check for image details in content
    const logoDetail = homepageItem.details?.find(detail => detail?.name === "home_icon");
    if (!logoDetail || !logoDetail.value) {
        console.warn("No valid image found for logo. Using default image");
    }

    // Set logo src and alt
    const logoSrc = (logoDetail && logoDetail.value) ? logoDetail.value : "img/logo_wht.svg";
    const logoAlt = homepageItem.description || "Brand Logo";

    // Check for existing logo image
    const existingLogo = logoContainer.querySelector(".logo__image");
    if (existingLogo) {
        // Update existing logo if it has changed
        if (existingLogo.src !== logoSrc) {
            existingLogo.src = logoSrc;
        }
        if (existingLogo.alt !== logoAlt) {
            existingLogo.alt = logoAlt;
        }
    } else {
        logoContainer.innerHTML = "";

        // Create new logo
        const logo = document.createElement("img");
        logo.className = "logo__image logo__image--wide";
        logo.alt = logoAlt;
        logo.src = logoSrc;

        logoContainer.appendChild(logo);
    }
}